import { render, staticRenderFns } from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=template&id=09e769b7&scoped=true"
import script from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DistribuicaoDeRequisicaoDeCompraView.vue?vue&type=style&index=0&id=09e769b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e769b7",
  null
  
)

export default component.exports